import $http from '@/services/common/http.service';
import { Paging, User } from '@/store/models';
import jwtService from '@/services/common/jwt.service';
import $backgroundService from '@/services/common/background.service';

export class ManagerService {
  public async loadManager(params?: {
    search_key?: string;
    order_by?: string;
    limit?: number;
    offset?: number;
  }) {
    const user = await jwtService.getUser();
    const response = await $backgroundService.query(
      `admins/${user.id}/managers`,
      params
    );
    return response.data.data as { managers: User[]; paging: Paging };
  }

  public async updateManager(
    id: number,
    params?: {
      firstName?: string;
      lastName?: string;
      jobTitle?: string;
      companyName?: string;
      filterClientByOrganisation?: string;
    }
  ) {
    const user = await jwtService.getUser();
    const response = await $http.update(
      `admins/${user.id}/managers`,
      `${id}`,
      params
    );
    return response.data.data as { managers: User[]; paging: Paging };
  }

  public async createManager(manager: {
    firstName: string;
    lastName: string;
    email: string;
    initialPassword: string;
    companyName: string;
    jobTitle: string;
    filterClientByOrganisation?: string;
  }) {
    const user = await jwtService.getUser();
    const response = await $http.post(`admins/${user.id}/managers`, manager);
    return response.data.data;
  }

  public async deleteManager(managerId: number) {
    const user = await jwtService.getUser();
    const response = await $http.delete(
      `admins/${user.id}/managers/${managerId}`
    );
    return response.data.data;
  }

  public async resetPassword(coachId: number, data: { password: string }) {
    const user = await jwtService.getUser();
    const response = await $http.put(
      `admins/${user.id}/managers/${coachId}/reset-password`,
      data
    );
    return response.data.data;
  }
}

const managerService = new ManagerService();
export default managerService;
